import { readPlotDocument, } from "./plotjson-reader.js";
import { createPlotFeature, } from "./types.js";
export function createPlotDocument(options) {
    return {
        type: "PlotLibreDocument",
        schemaVersion: "1.0.0",
        id: options.id,
        name: options.name,
        features: (options.features ?? []).map(createPlotFeature),
        metadata: { ...(options.metadata ?? {}) },
    };
}
export function serializePlotDocument(document) {
    return JSON.stringify(document, null, 2);
}
/**
 * Compatibility wrapper for callers that need the current PlotDocument only.
 * Use readPlotDocument() when migration and normalization evidence is required.
 */
export function parsePlotDocument(value, options = {}) {
    return readPlotDocument(value, options).document;
}
//# sourceMappingURL=plotjson.js.map